var applyProject = [
  {
    id: 1,
    name: '食品经营许可',
  },
  {
    id: 2,
    name: '食品小餐饮登记（经营场所面积不足五十平方米的餐饮服务经营者）',
  },
  {
    id: 3,
    name: '卫生许可证',
  },
  {
    id: 4,
    name: '道路货物运输经营许可',
  },
  {
    id: 5,
    name: '出版物零售许可',
  },
  {
    id: 6,
    name: '户外招牌设施设置规范管理',
  },
  {
    id: 7,
    name: '创业补贴申领',
  },
]

export default applyProject